import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 38.5,
	viewBox: "0 0 32 34",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentcolor",
		d: "M19.3516,31.0484c7.227,-1.541,12.648,-7.961,12.648,-15.648c0,-8.837,-7.163,-16,-16,-16c-8.836,0,-16,7.163,-16,16c0,7.687,5.421,14.107,12.649,15.648l2.644,2.645c0.391,0.39,1.024,0.39,1.415,-0.001l2.644,-2.644z"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 15.5,
		r: 14,
		stroke: "none"
	})] })
});
export default SvgPin;
